import { OnDestroy, ApplicationRef, TemplateRef, EmbeddedViewRef, Injector, ComponentRef } from '@angular/core';
import { isNullOrEmpty } from '@awp/core/utils';
import { DynamicOutletService } from '@awp/dynamic-outlet';
var ContentOutletDirective = /** @class */ (function () {
    function ContentOutletDirective(injector, attachedTemplateRef) {
        this.injector = injector;
        this.attachedTemplateRef = attachedTemplateRef;
    }
    ContentOutletDirective.prototype.ngOnDestroy = function () {
        this.destroyComponent();
    };
    ContentOutletDirective.prototype.createComponent = function (element) {
        var _this = this;
        this.destroyComponent();
        if (this.templateRef != null) {
            // Attach to the specified template reference
            this._viewRef = this.templateRef.createEmbeddedView(null);
            this.applicationRef.attachView(this._viewRef);
            var domElement = this._viewRef.rootNodes[0];
            element.appendChild(domElement);
            if (this._viewRef != null) {
                this._viewRef.markForCheck();
            }
        }
        else if (!isNullOrEmpty(this.componentName)) {
            // Attach to specified component name
            this.outletService.getComponent(this.componentName, this.injector)
                .then(function (componentRef) {
                _this._componentRef = componentRef;
                _this.applicationRef.attachView(componentRef.hostView);
                var domElem = componentRef.hostView.rootNodes[0];
                element.appendChild(domElem);
                componentRef.changeDetectorRef.markForCheck();
            });
        }
        else if (this.attachedTemplateRef != null) {
            // Attach using current ng-template reference where the directive is currently specified.
            element.innerHTML = '';
            this._viewRef = this.attachedTemplateRef.createEmbeddedView(null);
            this.applicationRef.attachView(this._viewRef);
            var domElement = this._viewRef.rootNodes[0];
            element.appendChild(domElement);
            if (this._viewRef != null) {
                this._viewRef.markForCheck();
            }
        }
    };
    Object.defineProperty(ContentOutletDirective.prototype, "applicationRef", {
        get: function () {
            if (this._applicationRef == null) {
                this._applicationRef = this.injector.get(ApplicationRef);
            }
            return this._applicationRef;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentOutletDirective.prototype, "outletService", {
        get: function () {
            if (this._dynamicOutletService == null) {
                this._dynamicOutletService = this.injector.get(DynamicOutletService);
            }
            return this._dynamicOutletService;
        },
        enumerable: true,
        configurable: true
    });
    ContentOutletDirective.prototype.destroyComponent = function () {
        if (this._viewRef) {
            this.applicationRef.detachView(this._viewRef);
            this._viewRef.destroy();
            this._viewRef = null;
        }
        if (this._componentRef) {
            this.applicationRef.detachView(this._componentRef.hostView);
            this._componentRef.destroy();
            this._componentRef = null;
        }
    };
    return ContentOutletDirective;
}());
export { ContentOutletDirective };
